import AOS from 'aos';

if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
  AOS.init({
    once: true,
    offset: 0,
    startEvent: 'load',
  });
}else{
  AOS.init({
    once: true,
    offset: 100,
    startEvent: 'load',
  });
}
AOS.refresh(true);

// $(window).on('scroll', function () {
//   AOS.refresh();
// });

// set transition delay to zero
$(document).on('mouseover', '.aos-animate.aos-init', function () {
  $(this).addClass('aos-animation-ready');
});
